import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';

import { StorageService } from '@fcom/core';

import { REFUNDS_FEATURE_KEY } from './constants';
import { reducer } from './store/reducers';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(REFUNDS_FEATURE_KEY, reducer)],
  providers: [StorageService],
  declarations: [],
  exports: [],
})
export class RefundsCommonModule {}
